<template>
	<div class="business-article">
		<article class="column">
			<div class="title-wrap">
				<h3>
					エンタープライズ領域
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/business_and_technology/image01.jpg" alt="" />
			</div>
			<div class="content">
				<div class="content-inner">
					<p class="content-catch">
						最上流から、現場の定着まで。<br />
						「世界標準」の技術で、クライアントをリードする。
					</p>
					<div class="content-text">
						<p>
							エンタープライズ領域の特長は、最上流の「課題設定」から、クライアントの現場の教育まで含めた「定着」までを、一気通貫で担うことです。クライアントからの要望をそのまま請けるのではなく、経営や事業の状況をもとに課題を設定し、クライアントとともにシステムの仕様を詰めていきます。自社のアーキテクトがシステムのアーキテクチャを描き、他社SIerと開発を進める中で、システム構築を支援。さらに、提供したシステムが現場でフルに活用され、保守までを担保できるように、クライアントのエンジニアの教育も担います。「コンサルティングで終わり」「システムの構築で終わり」ではありません。提供したシステムが機能して、クライアントの事業が成長することをゴールに置いた、より本質的な仕事ができます。
						</p>
						<p>
							この一連のプロセスの中で重要な役割を占めるのが、UMLやドメイン駆動設計、アジャイルプロセス、クラウドネイティブといった「世界標準」の工学的な技術です。クライアントのビジネスの核心価値を理解し、「何をつくるべきか」を明確にして「いかに、効率よくつくれるか」を実現します。豆蔵は、オブジェクト指向のエキスパートたちが立ち上げた会社で、技術を大切にするカルチャーが根付いています。それぞれの技術に精通した技術者が在籍しており、多くの書籍やメディアの記事を執筆しているほどです。また、独立系企業のため、フラットな立ち位置でソリューションを提案できることも強みの1つになっています。
						</p>
						<p>
							DX（デジタルトランスフォーメーション） 時代が今後本格化する中で、(1)
							クライアントのビジネス上の課題を可視化し、解決に導くためのシステム化構想、(2)
							ビジネスの変化にいち早く対応するためのアーキテクチャ、(3) それを支える開発プロセス、そして (4)
							内製化を目的とした人材育成は今後ますます重要になってきます。エンタープライズ領域では、この 4
							つのサービスを主軸とし、「絵に描いた餅で終わらせない」エンジニアリングサービスを提供し続けます。
						</p>
					</div>
				</div>
			</div>
			<div class="case">
				<div class="case-inner">
					<p class="case-title">
						エンタープライズ領域の事例紹介
					</p>
					<div class="case-text">
						<p class="case-catch">
							「20年に一度の大改修」と言われた大手金融系企業の基幹システムの刷新。
						</p>
						<p>
							ある大手金融系企業の基幹システムの刷新を行いました。「20年に一度の大改修」と言われたそのプロジェクトでは、ホスト系からWeb系へとシステムを移行して、ユーザビリティを大きく改善。また、あらゆるサービスの顧客情報を一元管理できるようになり、クライアントから高い評価をいただいています。
						</p>
						<p>
							このプロジェクトの成功の要因として、3つの要素が挙げられます。1つ目は、開発の目的を明確に定義したことです。このシステムは何のためにつくるのか、つくるためにはどのような技術とアーキテクチャが必要なのか。そのような議論をかなりの時間を掛けて行いました。2つ目は、技術力、課題解決力の高いチームを組織し、スキルトランスファーを丁寧に行ったことです。コンサルティングだけではなく、課題の解決や教育をしっかりと行うことにより、クライアント内の現場エンジニアの開発力や運用力が向上しました。そして、3つ目の要因は、開発自体を効率化したことです。自動化ツールをつくったり、開発のルールを選定したり、数年先を見越して開発手法を改善する活動を行いました。これにより、数百人に上る開発者の成果物の品質を保つことに貢献しました。これらの取り組みによって、この基幹システム刷新プロジェクトは無事にカットオーバーを迎えました。現在でも、さらなる進化を実装するために、このプロジェクトは継続しています。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column">
			<div class="title-wrap">
				<h3>
					AI・データサイエンス領域
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/business_and_technology/image02.jpg" alt="" />
			</div>
			<div class="content">
				<div class="content-inner">
					<p class="content-catch">
						大学との連携で磨かれた最先端技術で、未知の課題に挑む。<br />
						独自プロダクトや人材育成サービスも提供も活発化。
					</p>
					<div class="content-text">
						<p>
							国内外の先進的な事例から、ビジネスの急速なデジタル化（デジタルトランスフォーメーション）の潮流をいち早く感知していた私たちは、AI/機械学習やデータサイエンス関連のソリューションに特化した「IT戦略支援事業部（現：デジタル戦略支援事業部）」を2014年に立ち上げました。クライアントは、金融業、商社、製造業、官公庁など、あらゆる業界が対象です。「AI/機械学習やデータサイエンスの技術を用いて事業を刷新したい」というクライアントの要望に対し、解決すべき課題としてのテーマを特定したうえで、そのテーマに対応する最適な最新テクノロジーやサービスを選定、提供しています。
						</p>
						<p>
							また、この領域では、豆蔵の技術力を積極的に活用した自社開発プロダクトやサービスも提供しています。対話型AIエンジン（チャットボット）『MZbot™』は、その代表的な例です。この対話型AIエンジンは、単なるチャットボットではなく、チャットを通じてRPAやサービスロボット、クラウドAPI、IoTセンサ等と連携し、あたかもデジタル秘書のように、多くの業務を代行させることができます。この『MZbot™』は、FAQのデータをインポートするだけでチャットボットを簡単に導入できることや、文書のレコメンド機能、意味検索機能等の他社に無い独自の機能を数多く搭載することで、大手企業を中心に30社以上のクライアントからの支持をいただいています。また、業務の自動化を推進するRPAにおいては単なる「ロボット作成代行」ではなく、RPAの効果を最大限に引き出すためのワンストップサービス「RPA
							Office ™」を提供しています。
						</p>
						<p>
							最先端の技術を理解し活用するべく、大学との連携を活発に行っているのも、この領域の特長です。九州大学、九州工業大学、一橋大学などの研究者との連携や人材交流を通じて、先端技術をビジネスに活用する『AIアスリート塾』や『データ分析Café』などの人材の育成事業において特に大きな成果を上げています。また、既存の事例が無い新しい領域のため、20代の若手社員の活躍も顕著です。『MZbot™』の開発を開始した2017年当時、新卒入社2年目だった社員がシステムのコア部分をほぼ一人で開発しました。現在では大幅に増員した開発チームの中心人物として活躍しています。
						</p>
					</div>
				</div>
			</div>
			<div class="case">
				<div class="case-inner">
					<p class="case-title">
						AI・データサイエンス領域の事例紹介
					</p>
					<div class="case-text">
						<p class="case-catch">
							大手総合商社のデジタルトランスフォーメーションを推進する「技術パートナー」に。
						</p>
						<p>
							大手総合商社でのプロジェクトでは、AIチャットボットやRPAなどの多岐にわたった技術適用を推進しています。技術を単に提供するだけではなく、たとえば、業務効率化のためのロボットコンテストの開催や、社員への教育研修に至るまで「RPA
							Office
							™」で支援するなど、クライアントご自身で最新技術を展開・実践できるようにするところまでサポートを行っています。このようなフルレンジでの対応力により、デジタルトランスフォーメーションのための「技術パートナー」としての総合的なサービスを提供しています。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column">
			<div class="title-wrap">
				<h3>
					組込み領域
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/business_and_technology/image03.jpg" alt="" />
			</div>
			<div class="content">
				<div class="content-inner">
					<p class="content-catch">
						メカやエレキの知見も提供。<br />
						自社ロボットも開発し、独自のポジションを築く。
					</p>
					<div class="content-text">
						<p>
							組込み領域の事業において、メインとなる領域は自動車とロボットです。自動運転の進化やロボットの高機能化によって、ソフトウェア開発が大規模化し、同時に高い品質も求められるようになりました。そのような時代の流れに対応するべく、豆蔵の強みであるオブジェクト指向やモデルベースによる抽象化技術を含めたシステムズエンジニアリングやソフトウエアエンジニアリングを駆使して、豆蔵は独自のポジションを築いています。
						</p>
						<p>
							特に、ロボット開発の領域においては、ソフトウェアだけでなく、メカ・エレキも含めて、システム全体で技術を提供できるようになり、これら全ての領域において、モデルベース技術を活用しています。また、実機無しで性能評価を行えるソフトウェア環境の構築などによって、開発期間を大幅に短縮することに成功しました。さらに、新たなロボット工学の知見を取り入れるために、大学との共同研究を行って、実用化への階段を一気に駆け上りました。今では、自社オリジナルのロボットシステムも開発できるようになっています。この結果、クライアントの経営ボードやCIOから、ロボット開発やファクトリーオートメーション化の依頼をいだたくことが増え、その製品の企画から豆蔵が携わるケースも多くなってきています。
						</p>
					</div>
				</div>
			</div>
			<div class="case">
				<div class="case-inner">
					<p class="case-title">
						組込み系の事例紹介
					</p>
					<div class="case-text">
						<p class="case-catch">
							海外メーカーの産業用ロボットシステムを開発。さらに進化を続けている。
						</p>
						<p>
							ロボット領域の事例としては海外メーカーの産業用ロボット開発プロジェクトが挙げられます。まずはロボットコントローラの新規開発を依頼され、その後にはロボットアームの新規開発も依頼されました。これにより、ソフトだけでなくメカ、エレキも含めてロボットを新規開発できる技術が獲得できました。その技術を発展させて自社のロボットシステム『Beanus』を開発して展示会に出展しております。それにより多数のロボット開発の引き合いをいただき、双腕ロボットの開発やオープンソースを用いたロボット開発のプロジェクトも発足しました。豆蔵のロボット開発は進化を続けています。
						</p>
					</div>
				</div>
			</div>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'business-article',
};
</script>

<style lang="scss" scoped>
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.business-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-bottom: 100px;
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 200px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
		left: -50%;
	}
	&:nth-child(1) {
		&:after {
			width: 150%;
			top: 0;
			transform-origin: left top;
		}
		&:before {
			width: 100%;
			bottom: 0;
			transform-origin: left top;
			left: -50%;
		}
	}
	&:nth-child(2) {
		&:after {
			width: 150%;
			top: 30%;
			transform-origin: left top;
		}
		&:before {
			width: 100%;
			bottom: -20%;
			transform-origin: left top;
			left: -50%;
		}
	}
	&:nth-child(3) {
		&:after {
			width: 150%;
			top: 60%;
			transform-origin: left top;
		}
		&:before {
			content: none;
		}
	}
}
.title-wrap {
	font-family: 'Noto Serif JP', serif;
	top: -30px;
	display: inline-block;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: absolute;
	@media print, screen and (max-width: 1160px) {
		font-size: 13px;
	}
	h3 {
		padding: 0 3em;
		text-align: center;
		position: relative;
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 50px 100px 100px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 50px 5% 50px 5%;
	}
}
.content-catch {
	font-size: 26px;
	font-family: 'Noto Serif JP', serif;
	@media print, screen and (max-width: 1160px) {
		font-size: 18px;
	}
}
.content-text {
	font-size: 12px;
	text-align: justify;
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}
</style>
